import './Theme/plugins/fancybox/jquery.fancybox.css';
import './Theme/css/css.css';
import './Theme/css/font-awesome-4.7.0/css/font-awesome.min.css';
import './Theme/css/animate.css';
import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import 'slick-carousel/slick/slick.css';
import Header from './Header';
import Menu from './CommonMenu';
import TintucPageApi from './TintucPageApi';
import { API_URL, FILE_URL, LINK_YOUTUBE_IMAGE } from './Constants';

import $ from 'jquery';
window.jQuery = $;
require('textillate');
require('letteringjs');
require('slick-carousel');


function TintucPageDetail() {
  const [data, setData] = useState([]);
  const [searchParams] = useSearchParams();
  const type = searchParams.get('type');

  const [title, setTitle] = useState();
  const postId = searchParams.get('id');

  useEffect(() => {
    $('.tlt').textillate({
      loop: true,
      minDisplayTime: 20000,
      in: {
        effect: 'fadeIn',
        delayScale: 3,
        shuffle: false,
      },
      out: {
        effect: 'fadeOut',
        delayScale: 1.5,
        delay: 100,
        sync: false,
        shuffle: false,
        reverse: false,
      }
    });

    $("#sky-bg").fadeIn(2e3);

    $(".slideHomeFade").slick({
      arrows: !1,
      lazyLoad: "ondemand",
      dots: !1,
      infinite: !0,
      speed: 2e3,
      fade: !0,
      slide: "div",
      autoplay: !0,
      autoplaySpeed: 2e3,
      cssEase: "linear"
    });

    $(".slideKinhSachUpdate").slick({
      infinite: !0,
      slidesToShow: 3,
      slidesToScroll: 3,
      autoplay: !0,
      speed: 3e3,
      dots: !1,
      autoplaySpeed: 5e3,
    });

    TintucPageApi.getChiTietTintuc(postId).then((data) => {
      if (data && data.length > 0) {
        setTitle(data[0].Title);
        setData(data); // Update state with the resolved data
      }
    })

    return () => {
      // Destroy Slick carousel to avoid memory leaks
      $('.slideHomeFade').slick('unslick');
      $('.slideKinhSachUpdate').slick('unslick');
    };

  }, []);
  return (
    <div>
      <meta httpEquiv="Content-Type" content="text/html; charset=UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />
      <meta httpEquiv="Content-Language" content="vi" />
      <title>Pháp Ấn Sơn | Linh Quy Pháp Ấn</title>
      <link rel="shortcut icon" href="/Upload/images/tab/logochuan.jpg" type="image/png" />
      <meta name="keywords" content="linh quy pháp ấn; linh quy phap an; Nikaya;  linhquyphapan; linhquy" />
      <meta name="description" content=" Pháp Ấn Sơn" />

      {/* <link href='https://fonts.googleapis.com/css?family=Roboto+Condensed|Open+Sans:400,700,400italic' rel='stylesheet' type='text/css'>
          <link href="/Theme/plugins/fancybox/jquery.fancybox.css" rel="stylesheet" />
          <link href="/Theme/css/css.css" rel="stylesheet"/>
          <link rel="stylesheet" href="/Theme/css/font-awesome-4.7.0/css/font-awesome.min.css">
          <link href="/Theme/css/animate.css" rel="stylesheet" />
          
          <script src="/Theme/js/jquery-1.11.2.min.js"></script> */}
      <div className="fly-text">
        <ul>
          <li className="tlt">Nguyện thành tựu</li>
          <li className="tlt">Lòng tin bất động</li>
          <li className="tlt">Nơi Đức Phật, Chánh Pháp</li>
          <li className="tlt">Chúng Tăng và Thánh Giới</li>
          <li className="tlt" />
        </ul>
      </div>
      <div id="sky-bg">
        <div className="clouds_one" />
        <div className="clouds_two" />
        <div className="clouds_three" />
      </div>
      <Header />

      <section>
        <div className="container contentContainer">
          <div className="row news-list">
            <div className="col-md-9  col-sm-9 col-xs-12">
              <ul className="breadcrumbs">
                <li>
                  <a href="/"><span>Linh Quy Pháp Ấn</span></a>
                </li>
                <li><span>›</span></li>
                <li>
                  <a href="/tin-tuc">
                    <span>Tin tức</span>
                  </a>
                </li>
                <li><span>›</span></li>
                <li>
                  <a href="/tin-tuc/loi-phat-day"><span>{title}</span></a>
                </li>
              </ul>
              {/* content  */}
              <h1>{title}</h1>
              <div className="row ">
                <div className="col-xs-12">

                  {data?.map((item, index) => (item.id == postId &&
                    <div className="list-news">
                      <div className="media">
                        <div>
                          <a href='#'>
                            <img className="media-object" src={FILE_URL + item.Thumb} alt={item.Title} title={item.Title} />
                          </a>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-12 col-sm-12 col-xs-12" id="detailVideoAudio">
                          <div
                            dangerouslySetInnerHTML={{ __html: item.Content }}>
                          </div>

                          <br /><br />
                          <hr />
                          {/* <h4>Nội dung khác</h4>
                          <ul className="nav nav-pills nav-stacked listDanhMuc">
                            <li className="drop link2">
                              <a href="/tin-tuc/thong-bao-khoa-tu-26-07-2024-den-ngay-01-08-2024">
                                <i className="fa fa-angle-right"></i> THÔNG BÁO KHÓA TU 26 / 07/ 2024 đến ngày 01 /08/ 2024
                              </a>
                            </li>
                            <li className="drop link2">
                              <a href="/tin-tuc/thong-bao-khoa-tu-xuat-gia-ngan-han-lan-10">
                                <i className="fa fa-angle-right"></i> THÔNG BÁO  KHÓA TU XUẤT GIA NGẮN HẠN LẦN 10
                              </a>
                            </li>
                            <li className="drop link2">
                              <a href="/tin-tuc/thong-bao-khoa-tu-9-ngay-tu-27-04-2024-den-ngay-05-05-2024">
                                <i className="fa fa-angle-right"></i> THÔNG BÁO KHÓA TU 9 ngày từ 27 / 04/ 2024 đến ngày 05 /05 / 2024.
                              </a>
                            </li>
                            <li className="drop link2">
                              <a href="/tin-tuc/thong-bao-khoa-tu-nikaya-xuat-gia-gieo-duyen-lan-9">
                                <i className="fa fa-angle-right"></i> THÔNG BÁO KHOÁ TU NIKAYA XUẤT GIA GIEO DUYÊN LẦN 9
                              </a>
                            </li>
                            <li className="drop link2">
                              <a href="/tin-tuc/99-">
                                <i className="fa fa-angle-right"></i> THÔNG BÁO KHÓA TU NIKAYA TẾT GIÁP THÌN 2024
                              </a>
                            </li>
                            <li className="drop link2">
                              <a href="/tin-tuc/thong-bao-khoa-tu-nikaya-tet-duong-lich">
                                <i className="fa fa-angle-right"></i> THÔNG BÁO KHÓA TU NIKAYA TẾT DƯƠNG LỊCH
                              </a>
                            </li>
                          </ul> */}
                        </div>
                      </div>

                    </div>
                  ))}

                </div>
              </div>
              {/* //content  */}
            </div>
            <div className="col-md-3 col-sm-3 col-xs-12">
              <div className="row">
                <div className="col-md-12 col-sm-12 col-xs-12 homeThongBao none-padding-left">
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 col-sm-12 col-xs-12  none-padding-left  boxNews">
                  <div className="containerRightBox">
                    <h5 className="titleRightHome">DANH MỤC TIN TỨC</h5>
                    <ul className="nav nav-pills nav-stacked listDanhMuc">
                      <li>
                        <a href="/tin-tuc/hoat- dong- hoang- phap">
                          <i className="fa fa-angle-right" /> Hoạt Động Hoằng Pháp
                        </a>
                      </li>
                      <li>
                        <a href="/tin-tuc/phat-phap-ung-dung">
                          <i className="fa fa-angle-right" /> Phật Pháp Ứng Dụng
                        </a>
                      </li>
                      <li>
                        <a href="/tin-tuc/loi-phat-day">
                          <i className="fa fa-angle-right" /> Lời Phật dạy
                        </a>
                      </li>
                      <li>
                        <a href="/tin-tuc/tt-soi-sang">
                          <i className="fa fa-angle-right" /> Soi sáng
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 col-sm-12 col-xs-12   none-padding-left">
                  <a className="playlistWidget" href="/danh-sach-playlist/1">
                    <img src={require("./Theme/img/show_playlist.png")} />
                  </a>
                </div>
                <div className="homestats col-md-12 col-sm-12 col-xs-12 none-padding-left">
                  <h5 className="tittleHome">LIÊN KẾT</h5>
                  <ul>
                    <li>
                      <i className="fa fa-facebook" />
                      <a href="https://www.facebook.com/LINH-QUY-PH%C3%81P-%E1%BA%A4N-260666811038785/" target="_blank">Facebook</a>
                    </li>
                    <li>
                      <i className="fa fa-youtube" />
                      <a href="https://www.youtube.com/channel/UCnI54Nrr9AddC4pDdpIjyCg" target="_blank">YouTube</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/*// content */}
      </section>

      <footer>
        <div className="container">
          <div className="_Slide3DContainer wow fadeInUp" data-wow-delay="0.4s">
            <ul className="carousel ">
              <li className="item active">
                <a href="/kinh-sach/cua-vao-bat-tu" className="itemSlide3d" tipcontent="CỬA VÀO BẤT TỬ"><img src={require("./Upload/images/z2345923129108_b9a2cd08e07aba3cab7e274c4c1896db.jpg")} /></a>
              </li>
              <li className="item">
                <a href="/kinh-sach/nghi-thuc-tu-hoc-nikaya" className="itemSlide3d"><img src={require("./Upload/images/Nghi Thức Tu Học NIKAYA(1).jpg")} /></a>
              </li>
              <li className="item">
                <a href="/kinh-sach/phap-hanh-nikaya-can-ban" className="itemSlide3d"><img src={require("./Upload/images/bìa pháp hành nikaya căn bản.png")} /></a>
              </li>
              <li className="item">
                <a href="/kinh-sach/tam-hy-ngot-ngao" className="itemSlide3d"><img src={require("./Upload/images/bìa pháp hành nikaya căn bản.png")} /></a>
              </li>
              <li className="item">
                <a href="/kinh-sach/tam-hien-van-an" className="itemSlide3d"><img src={require("./Upload/images/bìa pháp hành nikaya căn bản.png")} /></a>
              </li>
            </ul>
          </div>
        </div>
      </footer>
      <section className="footer-copyright">
        <div className="container">
          <div className="row">
            <div className="col-md-1">
              <img className="img-responsive" src={require("./Theme/img/linhqquylogo-small.jpg")} />
            </div>
            <div className="col-md-5">
              Copyright © 2011 - 2024<br />Linhquyphapan.vn, All right reserved <br />Chủ nhiệm: Thượng Toạ Thích Minh Thành
            </div>
            <div className="col-md-6">
              Thôn 4 - Xã Lộc Thành - Huyện Bảo Lâm - Tỉnh Lâm Đồng <br />SĐT: 0963 232 651 , 0766 522 181<br />Email: linhquyphapan@yahoo.com <br /> www.linhquyphapan.vn
            </div>
          </div>
        </div>
      </section>
      <p id="back-top" style={{ display: 'none' }}>
        <a href="#top"><span /></a>
      </p>
      <div id="fb-root" />
    </div>
  );
}

export default TintucPageDetail;
